import { useGeneratorStore, type ArtStyle, type QualityTier } from '../generatorStore';

const ageOptions = [
  { value: '2-5', label: '2-5 岁（幼儿）' },
  { value: '3-8', label: '3-8 岁（学龄前）' },
  { value: '6-12', label: '6-12 岁（小学）' },
];

const langOptions = [
  { value: 'zh', label: '中文' },
  { value: 'en', label: 'English' },
];

const styleOptions: { value: ArtStyle; label: string; emoji: string }[] = [
  { value: '童话', label: '童话', emoji: '\u{1F9DA}' },
  { value: '水彩', label: '水彩', emoji: '\u{1F3A8}' },
  { value: '科幻', label: '科幻', emoji: '\u{1F680}' },
  { value: '油画', label: '油画', emoji: '\u{1F5BC}' },
  { value: '3D', label: '3D', emoji: '\u{1F9CA}' },
  { value: '剪纸', label: '剪纸', emoji: '\u{2702}' },
  { value: '素描', label: '素描', emoji: '\u{270F}' },
];

const tierOptions: { value: QualityTier; label: string; emoji: string }[] = [
  { value: 'fast', label: '快速', emoji: '\u{26A1}' },
  { value: 'balanced', label: '均衡', emoji: '\u{2696}' },
  { value: 'pro', label: '专业', emoji: '\u{1F48E}' },
];

export default function ConfigStep() {
  const { params, setParams, setStep } = useGeneratorStore();

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>配置绘本参数</h2>
      <p style={subtitleStyle}>调整绘本的页数、风格和语言</p>

      <div style={sectionStyle}>
        <label style={labelStyle}>页数：{params.pages} 页</label>
        <input
          type="range"
          min={5}
          max={20}
          value={params.pages}
          onChange={(e) => setParams({ pages: Number(e.target.value) })}
          style={rangeStyle}
        />
        <div style={rangeLabelsStyle}>
          <span>5</span>
          <span>20</span>
        </div>
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>年龄段</label>
        <div style={selectWrapStyle}>
          <select
            value={params.ageGroup}
            onChange={(e) => setParams({ ageGroup: e.target.value })}
            style={selectStyle}
          >
            {ageOptions.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>语言</label>
        <div style={langGridStyle}>
          {langOptions.map((o) => (
            <button
              key={o.value}
              onClick={() => setParams({ language: o.value })}
              style={{
                ...langBtnStyle,
                background: params.language === o.value ? 'rgba(124,77,255,0.3)' : 'rgba(255,255,255,0.06)',
                borderColor: params.language === o.value ? 'rgba(124,77,255,0.5)' : 'rgba(255,255,255,0.1)',
              }}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>艺术风格</label>
        <div style={styleGridStyle}>
          {styleOptions.map((s) => (
            <button
              key={s.value}
              onClick={() => setParams({ style: s.value })}
              style={{
                ...styleBtnStyle,
                background: params.style === s.value ? 'rgba(124,77,255,0.3)' : 'rgba(255,255,255,0.06)',
                borderColor: params.style === s.value ? 'rgba(124,77,255,0.5)' : 'rgba(255,255,255,0.1)',
              }}
            >
              <div style={styleEmojiStyle}>{s.emoji}</div>
              <div style={styleLabelStyle}>{s.label}</div>
            </button>
          ))}
        </div>
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>质量等级</label>
        <div style={tierGridStyle}>
          {tierOptions.map((t) => (
            <button
              key={t.value}
              onClick={() => setParams({ tier: t.value })}
              style={{
                ...tierBtnStyle,
                background: params.tier === t.value ? 'rgba(124,77,255,0.3)' : 'rgba(255,255,255,0.06)',
                borderColor: params.tier === t.value ? 'rgba(124,77,255,0.5)' : 'rgba(255,255,255,0.1)',
              }}
            >
              <span style={tierEmojiStyle}>{t.emoji}</span>
              <span>{t.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div style={actionsStyle}>
        <button onClick={() => setStep('theme')} style={btnSecondaryStyle}>
          ← 上一步
        </button>
        <button onClick={() => setStep('style')} style={btnPrimaryStyle}>
          下一步 →
        </button>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  maxWidth: '600px',
  margin: '0 auto',
  padding: '40px 20px',
};

const titleStyle: React.CSSProperties = {
  fontSize: '28px',
  fontWeight: 'bold',
  color: '#fff',
  marginBottom: '8px',
  textAlign: 'center',
};

const subtitleStyle: React.CSSProperties = {
  fontSize: '14px',
  color: 'rgba(255,255,255,0.5)',
  marginBottom: '40px',
  textAlign: 'center',
};

const sectionStyle: React.CSSProperties = {
  marginBottom: '28px',
};

const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: '14px',
  color: 'rgba(255,255,255,0.7)',
  marginBottom: '10px',
};

const rangeStyle: React.CSSProperties = {
  width: '100%',
  accentColor: '#7c4dff',
};

const rangeLabelsStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '12px',
  color: 'rgba(255,255,255,0.4)',
  marginTop: '4px',
};

const selectWrapStyle: React.CSSProperties = {
  position: 'relative',
};

const selectStyle: React.CSSProperties = {
  width: '100%',
  padding: '12px 16px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.15)',
  background: 'rgba(255,255,255,0.05)',
  color: '#fff',
  fontSize: '15px',
  outline: 'none',
  cursor: 'pointer',
  appearance: 'none',
};

const langGridStyle: React.CSSProperties = {
  display: 'flex',
  gap: '10px',
};

const langBtnStyle: React.CSSProperties = {
  flex: 1,
  padding: '12px 16px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.1)',
  color: '#fff',
  fontSize: '14px',
  cursor: 'pointer',
  background: 'rgba(255,255,255,0.06)',
};

const styleGridStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '10px',
};

const styleBtnStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '6px',
  padding: '14px 8px',
  borderRadius: '12px',
  border: '1px solid rgba(255,255,255,0.1)',
  color: '#fff',
  fontSize: '12px',
  cursor: 'pointer',
  background: 'rgba(255,255,255,0.06)',
};

const styleEmojiStyle: React.CSSProperties = {
  fontSize: '24px',
};

const styleLabelStyle: React.CSSProperties = {
  fontSize: '12px',
  color: 'rgba(255,255,255,0.7)',
};

const tierGridStyle: React.CSSProperties = {
  display: 'flex',
  gap: '10px',
};

const tierBtnStyle: React.CSSProperties = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  padding: '12px 16px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.1)',
  color: '#fff',
  fontSize: '14px',
  cursor: 'pointer',
  background: 'rgba(255,255,255,0.06)',
};

const tierEmojiStyle: React.CSSProperties = {
  fontSize: '18px',
};

const actionsStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '40px',
};

const btnSecondaryStyle: React.CSSProperties = {
  padding: '12px 24px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.2)',
  background: 'transparent',
  color: 'rgba(255,255,255,0.7)',
  fontSize: '15px',
  cursor: 'pointer',
};

const btnPrimaryStyle: React.CSSProperties = {
  padding: '12px 32px',
  borderRadius: '10px',
  border: 'none',
  background: 'linear-gradient(135deg, #7c4dff 0%, #448aff 100%)',
  color: '#fff',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
};
